import { AppConfigModel } from "../abstract/app-config.model";

export class PartnerType extends AppConfigModel {

    static override CLASS_NAME: string = 'PartnerType';
}
